import GeneratedRoomServiceApi from "./generated/GeneratedRoomServiceApi"

class RoomServiceApi extends GeneratedRoomServiceApi {

}

export const roomServiceApi = new RoomServiceApi()
